var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFirstAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7484 2.64298C35.7484 5.00135 37.3083 7.02714 39.5582 7.72256C51.1077 11.3206 59.1473 22.9613 57.2274 36.1441C55.5774 47.4219 46.3079 56.4322 35.0884 57.7625C19.6691 59.5767 6.52976 47.4219 6.52976 32.2437C6.52976 20.7541 14.0594 11.0182 24.4389 7.7528C26.6888 7.05738 28.2787 5.03159 28.2787 2.67321C28.2787 1.67544 27.3788 0.859074 26.3888 1.04049C11.0295 3.82217 -0.459912 17.791 0.56004 34.2997C1.57999 50.8083 14.8394 63.3561 30.7686 63.9608C48.7378 64.6562 63.4971 50.1734 63.4971 32.2437C63.4971 16.6421 52.3376 3.70122 37.6383 1.01025C36.6483 0.828838 35.7484 1.6452 35.7484 2.64298Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9098 13.9099C41.8998 13.9099 49.9998 22.0399 49.9998 31.9999C49.9998 41.9599 41.8698 50.0899 31.9098 50.0899C21.9498 50.0899 13.8198 41.9599 13.8198 31.9999C13.8198 22.0399 21.9498 13.9099 31.9098 13.9099ZM31.9098 12.4099C21.0798 12.4099 12.3198 21.1699 12.3198 31.9999C12.3198 42.8299 21.0798 51.5899 31.9098 51.5899C42.7398 51.5899 51.4998 42.8299 51.4998 31.9999C51.4998 21.1699 42.7398 12.4099 31.9098 12.4099Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFirstAccess);
export default __webpack_public_path__ + "static/media/ic-first-access.7c5d13a20f4cc532a23b14ce66275192.svg";
export { ForwardRef as ReactComponent };